import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
const listeners = new Set();

const load = () =>
  axios.get(`${API}/catalog`).then(({ data }) => {
    cache = data.products;
    listeners.forEach((fn) => fn(cache));
    return cache;
  });

/** Live catalog (prices edited in the back office). Returns null until loaded. */
export const useCatalog = () => {
  const [catalog, setCatalog] = useState(cache);
  useEffect(() => {
    listeners.add(setCatalog);
    if (!cache) load().catch(() => {});
    return () => listeners.delete(setCatalog);
  }, []);
  return catalog;
};

export const formatPrice = (n) => (Number.isInteger(n) ? `${n}` : n.toFixed(2));
